import { NoticeExtractorCaseInformationResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  data?: NoticeExtractorCaseInformationResponseDto;
};

export function CaseInformationCard({ data }: TProps) {
  return (
    <section className="min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Case information</h3>
      <DataRows
        rows={[
          { label: 'Case name', value: data?.case_name },
          { label: 'Case number', value: data?.case_number },
          { label: 'Court', value: data?.court },
          { label: 'Division', value: data?.division },
        ]}
      />
    </section>
  );
}
